module.exports = __webpack_public_path__ + "static/img/platform-group1.aa512ae0.png";